import { MessagesSquare, BookOpen, UserCheck, Award } from "lucide-react";
import { Reveal } from "./Reveal";
import { BENEFITS } from "./data";

const ICONS = { chat: MessagesSquare, book: BookOpen, user: UserCheck, award: Award };

export const Benefits = () => (
    <section id="benefit" className="scroll-mt-20 bg-[#F8F6F1] py-20 lg:py-28" data-testid="benefits-section">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mx-auto max-w-2xl text-center">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">Benefit Kelas</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="benefits-heading">
                    Bukan Sekadar Ikut Kelas.{" "}
                    <span className="font-accent italic text-[#123E65]">Ini yang Akan Kamu Dapatkan.</span>
                </h2>
            </Reveal>
            <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="benefits-cards">
                {BENEFITS.map((b, i) => {
                    const Icon = ICONS[b.icon];
                    return (
                        <Reveal key={b.title} delay={i * 0.08}>
                            <div className="group h-full rounded-2xl border border-[#071B37]/8 bg-white p-7 text-center shadow-[0_8px_32px_rgba(7,27,55,0.06)] transition-all duration-300 hover:-translate-y-2 hover:border-[#DDB56C]/50 hover:shadow-[0_16px_40px_rgba(7,27,55,0.12)]" data-testid={`benefit-card-${i + 1}`}>
                                <div className="mx-auto mb-5 inline-flex rounded-full bg-[#071B37] p-4 transition-colors duration-300 group-hover:bg-[#123E65]">
                                    <Icon className="h-6 w-6 text-[#DDB56C]" strokeWidth={1.5} />
                                </div>
                                <h3 className="text-lg font-bold text-[#1C2533]">{b.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-[#1C2533]/70">{b.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-8 text-center text-xs text-[#1C2533]/55 sm:text-sm" data-testid="benefits-note">
                    *Mekanisme sesi konsultasi 1-on-1 mengikuti ketentuan penyelenggara.
                </p>
            </Reveal>
        </div>
    </section>
);
